module.exports = __webpack_public_path__ + "img/undraw_Building_re_xfcm.99b77c9d.svg";